import StoreUtilClass from "../../../shared/application/utils/store-util";
export default new StoreUtilClass("user_api_token");
